import React, {useState} from 'react';
import {makeStyles} from '@mui/styles';
import {
  Button,
  Grid,
  IconButton,
  List,
  SwipeableDrawer,
  Toolbar,
  Typography,
} from '@mui/material';
import useScreenWidth from '../../../hooks/useScreenWidth';
import {theme} from '../../../Theme';
import {Close, Menu} from '@mui/icons-material';
import {LazyRequestQuoteDialog} from '../../../common/LazyLoader';

const useStyles = makeStyles(() => ({
  tabButton: {
    fontSize: 17,
    fontWeight: 400,
  },
  listRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0 16px',
  },
}));

interface IProps {
  user: any;
  pageValue: string;
  setPageValue: any;
}

export default function WebsiteToolbar({
  user,
  pageValue,
  setPageValue,
}: IProps) {
  const classes = useStyles();
  const width = useScreenWidth();

  const [drawerOpen, setDrawerOpen] = useState(false);

  const changePageValue = (page: string) => {
    setPageValue(page);
    setDrawerOpen(false);

    const el = document.getElementById('mainScrollDiv');
    el?.scrollTo({top: 0});
  };

  return (
    <>
      {width > 600 ? (
        <Toolbar
          style={{
            height: 72,
            boxShadow: '0px 4px 10px -4px rgba(0, 0, 0, 0.15)',
          }}>
          <Grid container alignItems="center" justifyContent="space-between">
            {user.logoImageUrl ? (
              <img
                alt={user?.name?.split(' ')[0] || 'Avatar'}
                src={user.logoImageUrl}
                style={{
                  height: 54,
                  width: 'auto',
                  maxWidth: 135,
                  objectFit: 'contain',
                }}
              />
            ) : (
              <Typography
                color="primary"
                style={{fontSize: 24, fontWeight: 500}}>
                {user.companyName}
              </Typography>
            )}
            <span>
              <Button
                style={{
                  color:
                    pageValue === 'projects'
                      ? theme.palette.primary.light
                      : theme.palette.gray.text,
                }}
                className={classes.tabButton}
                onClick={() => changePageValue('projects')}>
                PAST PROJECTS
              </Button>
              <Button
                style={{
                  color:
                    pageValue === 'about'
                      ? theme.palette.primary.light
                      : theme.palette.gray.text,
                  marginLeft: 32,
                  marginRight: 40,
                }}
                className={classes.tabButton}
                onClick={() => changePageValue('about')}>
                ABOUT
              </Button>
              <LazyRequestQuoteDialog user={user} />
            </span>
          </Grid>
        </Toolbar>
      ) : (
        <Toolbar
          style={{
            minHeight: 52,
            boxShadow: '0px 4px 10px -4px rgba(0, 0, 0, 0.15)',
          }}>
          <Grid container alignItems="center" justifyContent="space-between">
            {user.logoImageUrl ? (
              <img
                alt={user?.name?.split(' ')[0] || 'Avatar'}
                src={user.logoImageUrl}
                style={{
                  height: 36,
                  width: 'auto',
                }}
              />
            ) : (
              <Typography
                color="primary"
                style={{fontSize: 16, fontWeight: 500}}>
                {user.companyName}
              </Typography>
            )}
            <IconButton
              onClick={() => setDrawerOpen(true)}
              style={{marginRight: -12}}
              size="large">
              <Menu color="primary" />
            </IconButton>
          </Grid>
        </Toolbar>
      )}

      <SwipeableDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onOpen={() => setDrawerOpen(true)}>
        <Toolbar>
          <Close
            onClick={() => setDrawerOpen(false)}
            style={{marginLeft: 'auto'}}
          />
        </Toolbar>
        <List style={{width: width}} className={classes.listRoot}>
          <Button
            style={{
              color:
                pageValue === 'projects'
                  ? theme.palette.primary.light
                  : theme.palette.gray.text,
              margin: '8px 0',
            }}
            className={classes.tabButton}
            onClick={() => changePageValue('projects')}>
            PAST PROJECTS
          </Button>
          <Button
            style={{
              color:
                pageValue === 'about'
                  ? theme.palette.primary.light
                  : theme.palette.gray.text,
            }}
            className={classes.tabButton}
            onClick={() => changePageValue('about')}>
            ABOUT
          </Button>
        </List>
        <Grid
          container
          justifyContent="center"
          style={{marginTop: 'auto', marginBottom: 20}}>
          <LazyRequestQuoteDialog user={user} gutters />
        </Grid>
      </SwipeableDrawer>
    </>
  );
}
